{
  "data": {
    "allPois": [
      {
        "id": "55717249",
        "shortName": "Harris Collection",
        "fullName": "Harris Learning Collection",
        "mapId": "harris",
        "websiteUrl": "https://harris.fieldmuseum.org/",
        "updatedAt": "2026-08-04T11:20:10-05:00",
        "sponsorAcknowledgment": "",
        "labelOverride": "",
        "labelAlignment": "",
        "description": "<p>The N. W. Harris Learning Collection at the Field Museum gives educators and parents a chance to take the Museum's collection to their classroom or home. Borrow these specimens, items, and related curricular materials for up to three weeks, and when you return your borrowed treasures, peruse the over 100-year-old Learning Collection to take something new.</p>\n<p><strong>Please note:</strong> The Harris Learning Collection will be closed from Wednesday, July 29 to Tuesday, November 3. for renovations. We will not be accepting any external reservations from Wednesday, July 29 to Tuesday, November 3.&nbsp;</p>",
        "colorCategory": "Amenity",
        "closed": "Open",
        "image": {
          "id": "22440703",
          "url": "https://www.datocms-assets.com/44232/1665071249-hlc_redfox-sittingadult_zm-004-3.jpg"
        }
      },
      {
        "id": "40217218",
        "shortName": "Evolving Planet",
        "fullName": "Griffin Halls of Evolving Planet & SUE the T. rex",
        "mapId": "evolving_planet",
        "websiteUrl": "https://www.fieldmuseum.org/exhibitions/evolving-planet",
        "updatedAt": "2026-08-04T11:16:11-05:00",
        "sponsorAcknowledgment": "<p>The <em>Griffin Halls of Evolving Planet</em> are part of the Griffin Dinosaur Experience, made possible by the generous support of the Kenneth C. Griffin Charitable Fund.</p>",
        "labelOverride": "",
        "labelAlignment": "center (default)",
        "description": "<p>Discover the many creatures that have roamed the earth throughout history, from single-celled organisms to our extended human family. You can see a variety of real fossils and experience the story of evolution, the process that connects all living things on Earth. Don’t miss the <em>Elizabeth Morse Genius Hall of Dinosaurs</em> to get up close and personal with more than a dozen of the biggest creatures in our history, and the <a href=\"https://www.fieldmuseum.org/exhibition/halls-and-galleries/meet-the-chicago-archaeopteryx\">Chicago <em>Archaeopteryx</em></a>, a rare fossil that reveals the evolutionary link between dinosaurs and birds. Then, experience the world of SUE the&nbsp;<em>T. rex</em>, our famous fossil with a big personality.</p>",
        "colorCategory": "Dinosaurs",
        "closed": "Open",
        "image": {
          "id": "16582068",
          "url": "https://www.datocms-assets.com/44232/1632764129-field2suevisitors1266-hewettwebexport.jpg"
        }
      },
      {
        "id": "40217238",
        "shortName": "Mammals",
        "fullName": "Mammals",
        "mapId": "mammals",
        "websiteUrl": "",
        "updatedAt": "2026-08-04T11:11:01-05:00",
        "sponsorAcknowledgment": "",
        "labelOverride": "",
        "labelAlignment": "",
        "description": "<p>Catch glimpse of mammals from Asia and Africa—from giraffes at a watering hole to monkeys peeking out from the canopy. These halls include dioramas with meticulously crafted landscapes and carefully preserved specimens to immerse you in their unique habitats.</p>\n<p><strong>Please note:</strong> <span>Beginning July 20, <em>What is an Animal? &amp; Animal Biology</em> and the adjoining galleries, will be closed as we complete a series of building improvements. The Bird Habitats gallery will close on July 20. <em>What is an Animal?</em> and the Mammals of Africa hall will close on August 3. Closures will remain in effect until October 23, 2026.</span></p>",
        "colorCategory": "Nature",
        "closed": "Open",
        "image": {
          "id": "16584387",
          "url": "https://www.datocms-assets.com/44232/1632763815-fieldmuseuminteractiveexhibitslhewett-201webexport.jpg"
        }
      },
      {
        "id": "40217224",
        "shortName": "What is an Animal?",
        "fullName": "What is an Animal? and Animal Biology ",
        "mapId": "animals",
        "websiteUrl": "https://www.fieldmuseum.org/exhibition/halls-and-galleries/what-animal-animal-biology",
        "updatedAt": "2026-08-04T11:09:41-05:00",
        "sponsorAcknowledgment": "",
        "labelOverride": "What is\nan Animal?",
        "labelAlignment": "",
        "description": "<p><span>Beginning July 20, <em>What is an Animal? &amp; Animal Biology</em> and the adjoining galleries, will be closed as we complete a series of building improvements. The Bird Habitats gallery will close on July 20. <em>What is an Animal?</em> and the Mammals of Africa hall will close on August 3. Closures will remain in effect until October 23, 2026.</span></p>",
        "colorCategory": "Nature",
        "closed": "Closed",
        "image": {
          "id": "16582032",
          "url": "https://www.datocms-assets.com/44232/1632764214-17-069-5583-andersonwebexport.jpg"
        }
      },
      {
        "id": "OvSFw1z8QYSOumDc5WuoZQ",
        "shortName": "Pokémon",
        "fullName": "Pokémon Fossil Museum",
        "mapId": "hall_7",
        "websiteUrl": "https://www.fieldmuseum.org/exhibition/Exhibition/pokemon",
        "updatedAt": "2026-05-18T11:22:18-05:00",
        "sponsorAcknowledgment": "<main class=\"container-fluid\">\n<div class=\"row\">\n<div class=\"container\" data-testid=\"main-wrapper\">\n<div class=\"row sponsor\">\n<div class=\"col-12 copy text-center\">\n<div dir=\"ltr\">\n<p></p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</main>\n<div class=\"info-bar-full\"></div>",
        "labelOverride": "",
        "labelAlignment": "",
        "description": "<div class=\"my-5\">\n<div class=\"row\">\n<div class=\"container\" data-testid=\"main-wrapper\">\n<div class=\"copy\">\n<p><span>⚡️The&nbsp;</span><em>Pok&eacute;mon Fossil Museum</em><span>&nbsp;exhibition will make its North American debut at the Field Museum on May 22, 2026 &mdash; April 11, 2027! This one-of-a-kind experience brings together the worlds of Pok&eacute;mon and paleontology, inviting visitors to compare fossil Pok&eacute;mon like Tyrantrum and Archeops with real-world fossils&mdash;including SUE the&nbsp;</span><em>T. rex</em><span>.</span></p>\n<p>From May 22, 2026&mdash;April 11, 2027!</p>\n</div>\n</div>\n</div>\n</div>\n<div class=\"my-5\"></div>\n<div class=\"exhibition-higlights\"></div>",
        "colorCategory": "Nature",
        "closed": "Open",
        "image": {
          "id": "G3HvgTs_Q9mNEUUdLwqV1g",
          "url": "https://www.datocms-assets.com/44232/1761855365-pokemon_header_blue.jpg"
        }
      },
      {
        "id": "40217243",
        "shortName": "Jurassic Ocean",
        "fullName": "Jurassic Oceans: Monsters of the Deep",
        "mapId": "",
        "websiteUrl": "https://www.fieldmuseum.org/exhibitions/jurassic-oceans-monsters-deep",
        "updatedAt": "2026-05-18T10:29:46-05:00",
        "sponsorAcknowledgment": "<p><em>Jurassic Oceans: Monsters of the Deep</em> was curated and produced by the Natural History Museum, London.</p>",
        "labelOverride": "",
        "labelAlignment": "",
        "description": "<p>Dive into the prehistoric seas that were home to enormous marine reptiles, crocodiles, and sharks. In <em>Jurassic Oceans: Monsters of the Deep</em>, meet the underwater giants that lived 200 million years ago. As dinosaurs reached new heights, sea creatures became larger, faster, and fiercer. Experience what it&rsquo;s like to stand (or swim) next to top predators like a plesiosaur&mdash;a reptile with flippers, a very long neck, and super sharp teeth. <em>The exhibition is presented in both English and Spanish. La exhibici&oacute;n est&aacute; presentada en ingl&eacute;s y espa&ntilde;ol.</em></p>",
        "colorCategory": "Dinosaurs",
        "closed": "Closed",
        "image": {
          "id": "16584634",
          "url": "https://www.datocms-assets.com/44232/1646154810-bait_ball_cnicholls2009.jpg"
        }
      },
      {
        "id": "Ze4FBvc_SgyTRH6gjBxbdA",
        "shortName": "Connecting Threads",
        "fullName": "Connecting Threads",
        "mapId": "",
        "websiteUrl": "https://www.fieldmuseum.org/exhibition/connecting-threads-africa-fashion-in-chicago",
        "updatedAt": "2026-04-01T09:42:19-05:00",
        "sponsorAcknowledgment": "",
        "labelOverride": "",
        "labelAlignment": "",
        "description": "<div class=\"exhibit-flyer-page__header-description\">\n<p>Opening February 28, 2025</p>\n<p>In this exhibit, Chicago designers celebrate their heritage, culture, and communities by creating looks inspired by items in the Field Museum collections and the vibrant African design scene in Chicago.</p>\n</div>",
        "colorCategory": "Culture",
        "closed": "Closed",
        "image": {
          "id": "MyBy24TAQD-26t3aZqHpRw",
          "url": "https://www.datocms-assets.com/44232/1771904002-connecting-threads-identity-image-7x5.webp"
        }
      },
      {
        "id": "40217245",
        "shortName": "Mastaba",
        "fullName": "Mastaba",
        "mapId": "mastaba",
        "websiteUrl": "",
        "updatedAt": "2026-01-07T11:42:48-06:00",
        "sponsorAcknowledgment": "",
        "labelOverride": "",
        "labelAlignment": "",
        "description": "<p>Step inside a three-story replica of a mastaba, a type of ancient Egyptian tomb. You can explore two authentic chamber rooms that are over 4,400 years old. They come from the burial site of Unis-Ankh, the son of Pharaoh Unis, who ruled in the 5th Dynasty. The original walls feature masterfully crafted reliefs, and the new walls are covered with hieroglyphs made using ancient methods. Continue your journey through the exhibition <em>Inside Ancient Egypt</em> by walking down the spiral staircase in the mastaba or taking the closest elevator to the ground level. There, you can see one of the largest collections of mummies in the United States: 23 human mummies and more than 30 animal mummies. And experience an ancient marketplace reconstructed from market scenes shown on tomb walls. The kid-friendly stalls are filled with goods, and the marketplace is filled with people engaged in everyday activities. <em>Inside Ancient Egypt</em> is an up-close look at the daily lives of ancient Egyptians and how they thought about death.</p>",
        "colorCategory": "Culture",
        "closed": "Closed",
        "image": {
          "id": "16579657",
          "url": "https://www.datocms-assets.com/44232/1642284170-17-069-5169-anderson_webexport.jpg"
        }
      },
      {
        "id": "40217222",
        "shortName": "Africa",
        "fullName": "Africa",
        "mapId": "africa",
        "websiteUrl": "https://www.fieldmuseum.org/exhibition/africa",
        "updatedAt": "2025-11-19T09:44:51-06:00",
        "sponsorAcknowledgment": "",
        "labelOverride": "",
        "labelAlignment": "",
        "description": "<p>The Field Museum closed its Africa Hall on October 6, 2025, in preparation for a reimagined gallery that will open in the spring of 2028.</p>",
        "colorCategory": "Culture",
        "closed": "Closed",
        "image": {
          "id": "16584104",
          "url": "https://www.datocms-assets.com/44232/1632764633-17-069-5047-andersonwebexport.jpg"
        }
      },
      {
        "id": "DZ_cG8UJTu2YJ79PVQvWXA",
        "shortName": "After the Dinosaurs",
        "fullName": "After the Age of Dinosaurs",
        "mapId": "hall_5",
        "websiteUrl": "https://www.fieldmuseum.org/exhibition/after-the-age-of-dinosaurs",
        "updatedAt": "2025-11-19T09:42:44-06:00",
        "sponsorAcknowledgment": "",
        "labelOverride": "",
        "labelAlignment": "",
        "description": "<div class=\"my-5\">\n<div class=\"row\">\n<div class=\"container\" data-testid=\"main-wrapper\">\n<div class=\"copy\">\n<p dir=\"ltr\" class=\"zfr3Q CDt4Ke \"><span>Discover how a colossal asteroid ended the dinosaurs' reign and paved the way for life&rsquo;s astonishing comeback, shaping the world we know today. Meet unfamiliar creatures, explore immersive media experiences, and marvel at fossils from the Field Museum's renowned collections. Open from&nbsp;</span><span>Aug 29, 2025&mdash; Jan 3, 2027.</span></p>\n</div>\n</div>\n</div>\n</div>",
        "colorCategory": "Dinosaurs",
        "closed": "Open",
        "image": {
          "id": "QXVxGqgUQh6mgjpQNbdQeA",
          "url": "https://www.datocms-assets.com/44232/1762889612-atd_cretaceous_lowres-illustration-by-jay-ryan-field-museum.jpg"
        }
      },
      {
        "id": "PCZfWBL6QuWaGBunTEwepg",
        "shortName": "Changing Face",
        "fullName": "The Changing Face of Science",
        "mapId": "comer_gallery",
        "websiteUrl": "https://www.fieldmuseum.org/exhibition/the-changing-face-of-science",
        "updatedAt": "2025-06-18T09:28:29-05:00",
        "sponsorAcknowledgment": "",
        "labelOverride": "",
        "labelAlignment": "",
        "description": "<p>Engage with the captivating stories of women and people of color in science and find inspiration for your own exploration. Discover how diverse perspectives, identities, and backgrounds uniquely contribute to scientific advancement.</p>",
        "colorCategory": "Culture",
        "closed": "Open",
        "image": {
          "id": "EcE0sTQWQRuvCy_3wP1IyQ",
          "url": "https://www.datocms-assets.com/44232/1747422099-cfos_ruane_desouza.jpg"
        }
      },
      {
        "id": "40217225",
        "shortName": "Máximo the Titanosaur",
        "fullName": "Máximo the Titanosaur",
        "mapId": "maximo",
        "websiteUrl": "https://www.fieldmuseum.org/exhibitions/maximo-titanosaur",
        "updatedAt": "2025-02-26T16:14:51-06:00",
        "sponsorAcknowledgment": "",
        "labelOverride": "Máximo\nthe\nTitanosaur",
        "labelAlignment": "",
        "description": "<p>Come face-to-face with the largest dinosaur ever discovered&mdash;the titanosaur <em>Patagotitan mayorum</em>. Named M&aacute;ximo, meaning &ldquo;maximum&rdquo; or &ldquo;most&rdquo; in Spanish. This long-necked, plant-eating dinosaur lived over 100 million years ago in what is now Patagonia, Argentina. Our titanosaur cast reaches 122 feet across and stands 28 feet tall at the head. Modeled from fossil bones, this cast conveys the sheer size of the biggest animal ever to live.&nbsp; <em>The exhibition is presented in both English and Spanish. La exhibici&oacute;n est&aacute; presentada en ingl&eacute;s y espa&ntilde;ol</em>.</p>",
        "colorCategory": "Dinosaurs",
        "closed": "Open",
        "image": {
          "id": "16583049",
          "url": "https://www.datocms-assets.com/44232/1632763919-fieldmuseummaximo-451-hewettwebexport.jpg"
        }
      },
      {
        "id": "40217208",
        "shortName": "Jades",
        "fullName": "Elizabeth Hubert Malott Hall of Jades",
        "mapId": "jades",
        "websiteUrl": "https://www.fieldmuseum.org/exhibition/elizabeth-hubert-malott-hall-of-jades",
        "updatedAt": "2025-02-26T11:06:29-06:00",
        "sponsorAcknowledgment": "",
        "labelOverride": "",
        "labelAlignment": "left",
        "description": "Get a close look at more than 450 jade objects from our collection. They tell the story of jade’s iconic role throughout China's history and how it has changed over time. In Neolithic China, the stone was used in burial rituals. During the Bronze Age, kings and warriors displayed jade objects as symbols of their status. Today artists create arresting jade pieces honoring the past, using intricate new techniques.\n\nFor millennia, jade has been described as possessing five virtues: benevolence, loyalty, wisdom, courage, and integrity. Discover more about its enduring importance to Chinese cultural traditions.",
        "colorCategory": "Nature",
        "closed": "Open",
        "image": {
          "id": "16582198",
          "url": "https://www.datocms-assets.com/44232/1632763538-17-069-1450-andersonwebexport.jpg"
        }
      },
      {
        "id": "CrHFwfSSSjmeLDNUXZ7mGQ",
        "shortName": "Audubon's Birds ",
        "fullName": "Audubon's Birds of America",
        "mapId": "brooker_gallery",
        "websiteUrl": "https://www.fieldmuseum.org/exhibition/audubon-s-birds-of-america",
        "updatedAt": "2025-02-26T11:04:54-06:00",
        "sponsorAcknowledgment": "",
        "labelOverride": "",
        "labelAlignment": "",
        "description": "<p><span>Art and science intersect on the three-foot-tall pages of one of the world&rsquo;s rarest books: Audubon's Birds of America.&nbsp;</span><span>Learn about the life of John James Audubon to uncover the complexities of his legacy, and soar through the 12-year process of creating these masterpieces of printmaking.</span></p>\n<p><i><span>The exhibition is presented in both English and Spanish. La exhibici&oacute;n est&aacute; presentada en ingl&eacute;s y espa&ntilde;ol.</span></i></p>",
        "colorCategory": "Nature",
        "closed": "Open",
        "image": {
          "id": "IEqzWTWmS5i5x1VF_IgrOw",
          "url": "https://www.datocms-assets.com/44232/1730480835-gn90797_ofm_231_01d_edited.jpg"
        }
      },
      {
        "id": "40217207",
        "shortName": "Family PlayLab",
        "fullName": "Crown Family PlayLab",
        "mapId": "playlab",
        "websiteUrl": "https://www.fieldmuseum.org/exhibition/crown-family-playlab",
        "updatedAt": "2025-02-26T11:01:21-06:00",
        "sponsorAcknowledgment": "",
        "labelOverride": "",
        "labelAlignment": "",
        "description": "<p>Designed for children between two and six years old, the <em>Crown Family PlayLab</em> is an interactive, hands-on space that makes learning an adventure. Early learners can explore world cultures through music, experience everyday life in a recreated pueblo, or pretend to be a paleontologist with dinosaur bones, and that&rsquo;s just the beginning. With opportunities for discovery for young children, this exhibition presents a new adventure every time you visit. We strive to welcome everyone to the <em>PlayLab</em>, which has wheelchair access, a nursing room, and a quiet reading corner.</p>",
        "colorCategory": "Amenity",
        "closed": "Open",
        "image": {
          "id": "16583633",
          "url": "https://www.datocms-assets.com/44232/1632764187-17-069-2163-andersonwebexport.jpg"
        }
      },
      {
        "id": "40217226",
        "shortName": "Ancient Egypt",
        "fullName": "Inside Ancient Egypt",
        "mapId": "egypt",
        "websiteUrl": "https://www.fieldmuseum.org/exhibition/inside-ancient-egypt",
        "updatedAt": "2025-02-26T11:00:24-06:00",
        "sponsorAcknowledgment": "",
        "labelOverride": "Ancient\nEgypt",
        "labelAlignment": "",
        "description": "<p><em>Inside Ancient Egypt</em> is an up-close look at the daily lives of ancient Egyptians and how they thought about death. Enter through the ground level to see one of the largest collections of mummies in the United States: 23 human mummies and more than 30 animal mummies. And experience an ancient marketplace reconstructed from market scenes shown on tomb walls. The kid-friendly stalls are filled with goods, and the marketplace is filled with people engaged in everyday activities. Continue your journey to the main level of the museum and step inside a three-story replica of a mastaba, a type of ancient Egyptian tomb. You can explore two authentic chamber rooms that are over 4,400 years old. They come from the burial site of Unis-Ankh, the son of the pharaoh Unis who reigned during the 5th Dynasty. This exhibition offers clues to ancient Egyptians&rsquo; lives on Earth and everything we may have in common with them.</p>",
        "colorCategory": "Culture",
        "closed": "Open",
        "image": {
          "id": "16579657",
          "url": "https://www.datocms-assets.com/44232/1642284170-17-069-5169-anderson_webexport.jpg"
        }
      },
      {
        "id": "40217214",
        "shortName": "Meteorites",
        "fullName": "Meteorites",
        "mapId": "meteorites",
        "websiteUrl": "https://www.fieldmuseum.org/exhibitions/meteorites",
        "updatedAt": "2025-01-30T13:50:24-06:00",
        "sponsorAcknowledgment": "",
        "labelOverride": "",
        "labelAlignment": "",
        "description": "<p>This exhibition, located in the<span>&nbsp;</span><em>Grainger Gallery<span>&nbsp;</span></em>on the upper level, offers fascinating insight into where these objects came from and what they&rsquo;re made of. Meteorites can contain minerals that are older than the sun and the planets, and they help to give us an idea of Earth's geological makeup when it first formed.</p>",
        "colorCategory": "Nature",
        "closed": "Open",
        "image": {
          "id": "16584242",
          "url": "https://www.datocms-assets.com/44232/1632764010-meteoritesimg0759-knightdropboxwebexport0.jpg"
        }
      },
      {
        "id": "cWREduUkT62Ioyy1YDLBqQ",
        "shortName": "Unseen Oceans",
        "fullName": "Unseen Oceans",
        "mapId": "",
        "websiteUrl": "https://www.fieldmuseum.org/exhibitions/unseen-oceans",
        "updatedAt": "2025-01-06T09:11:43-06:00",
        "sponsorAcknowledgment": "",
        "labelOverride": "",
        "labelAlignment": "",
        "description": "<div class=\"col-md-7 mb-md-0 mb-4 bg-white z-index-10\">\n  <div class=\"mb-5 copy\">\n    <section class=\"field field-name-body field-type-text-with-summary field-label-hidden\">\n      <p><span>Embark on a journey from the oceans&rsquo; white-capped waves to their inky depths as you discover the latest ocean science in an&nbsp;</span><span>immersive new exhibition that will make a splash with the whole family.</span></p>\n    </section>\n  </div>\n</div>",
        "colorCategory": "Nature",
        "closed": "Closed",
        "image": {
          "id": "OHEKICC2S7y1TmYGSKGB9A",
          "url": "https://www.datocms-assets.com/44232/1703101418-9-triton-submersible_df.jpg"
        }
      },
      {
        "id": "8BMHPNbDRMOe5-iMy4zsMQ",
        "shortName": "Bloodsuckers",
        "fullName": "Bloodsuckers: Legends to Leeches",
        "mapId": "",
        "websiteUrl": "https://www.fieldmuseum.org/exhibitions/bloodsuckers-legends-to-leeches",
        "updatedAt": "2024-12-03T13:53:15-06:00",
        "sponsorAcknowledgment": "",
        "labelOverride": "",
        "labelAlignment": "",
        "description": "<p><span>Check out larger-than-life models of bloodsucking creatures and learn how different bloodsuckers earned their titles. Use magnifying glasses to see fossilized bloodsuckers up close. Step into the sounds of a Northwoods mosquito swarm, then play a game to discover which repellants best protect us from their bites. Take a journey through classic movies like&nbsp;</span><i><span>Dracula&nbsp;</span></i><span>in a mini movie theater and see a historical vampire hunting kit to discover where fact meets fiction.</span></p>",
        "colorCategory": "Nature",
        "closed": "Closed",
        "image": {
          "id": "68363919",
          "url": "https://www.datocms-assets.com/44232/1693232153-public-relations-bloodsuckers-rectangle.jpg"
        }
      },
      {
        "id": "55347922",
        "shortName": "Changing Face",
        "fullName": "The Changing Face of Science",
        "mapId": "rice_gallery",
        "websiteUrl": "https://www.fieldmuseum.org/exhibitions/changing-face-science",
        "updatedAt": "2024-09-03T09:22:15-05:00",
        "sponsorAcknowledgment": "",
        "labelOverride": "",
        "labelAlignment": "",
        "description": "<div class=\"col-12 mb-5 mb-md-0 col-md-5\" data-testid=\"check-left\">\n  <div class=\"copy\">\n    <h3 id=\"explore-jingmais-path-into-science-and-find-your-own\">Explore Jingmai&rsquo;s path into science &mdash; and find your own.</h3>\n    <p>Meet Jingmai O&rsquo;Connor, punk-rock paleontologist and the Field Museum&rsquo;s Associate Curator of Fossil Reptiles&mdash; aka the dinosaur curator. Come along on Jingmai's journey to learn how her interest in science began, see real fossils unearthed by Jingmai, and visit her fossil prep workspace. Discover the ways personal passions can overlap with science to create your own path toward becoming a scientist.</p>\n    <ul>\n      <li>Jingmai O'Connor's exhibition is in Rice Hall on the main level through June 23, 2024</li>\n    </ul>\n  </div>\n</div>\n<div class=\"col-12 mb-5 mb-md-0 col-md-6 offset-md-1\" data-testid=\"check-left\">\n  <div class=\"row h-100 align-items-center\">\n    <div class=\"container\">\n      <figure class=\"row image-full \">\n        <div class=\"col-12\"></div>\n      </figure>\n    </div>\n  </div>\n</div>",
        "colorCategory": "Culture",
        "closed": "Closed",
        "image": {
          "id": "64472026",
          "url": "https://www.datocms-assets.com/44232/1691510663-copy-of-northern-alberta-fieldwork-2-edited.png"
        }
      }
    ]
  }
}
